import { Dropdown, DropdownListItem, FInter, FlexBox } from "@brg/ui";
import { FC, ReactNode, useMemo } from "react";
import { ApprovedIcon } from "shared/icons/ApprovedIcon";
import ArrowTopIconWithText from "shared/icons/ArrowTopIconWithText";
import styled, {css, ThemeProvider, useTheme} from 'styled-components';
import {useTranslation} from "react-i18next";
import { useSelector } from "react-redux";
import { ThemeSlideColorSelector } from "../../../reducers/ThemeSlideColorSlice";
import { AppTester } from "supporting";
import { LayoutConst } from "core";

export interface LinksItems {
    action: () => void;
    isLinks: boolean;
    element: ReactNode;
  }

const DropdownText = styled(FInter.SmallTextBoldMagic)<{ isActive?: boolean }>`
  font-size: 15px;
  line-height: 20px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: ${p => p?.isActive ? p.theme.icon.active : p.theme.icon.hoverSpecialActive};
`;

export const DropDownWrapper = styled(FlexBox)<{ 
  isGameDeziiign?: boolean, 
  dropdownHeight?: number | string | undefined, 
  showScroll?: boolean, 
  isAcademy?: boolean,
  isCompetition?: boolean
}>`
    position: relative;
  
  .dropdown-show {
    height: auto;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1000;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

    >div{
      overflow: ${({showScroll}) => showScroll ? 'auto' : 'visible'} !important;
      ${({showScroll}) => showScroll && `
        &::-webkit-scrollbar {
            height: 1px;
            width: 2px;
          }
          &::-webkit-scrollbar-track {
            border-radius: 10px;
            background: ${({theme}: any) => theme.competition.input.bgActive} !important;
          }
          &::-webkit-scrollbar-thumb {
            background: ${({theme}: any) => theme.competition.input.inputText} !important;
          }
      `}
    }

    ${({ showScroll, theme, dropdownHeight }) => showScroll && `
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 40px;
        background: ${dropdownHeight === 0 ? `` : `linear-gradient(to top, ${theme.navigationBar.login.dropDownBackground} 0%, ${theme.navigationBar.login.dropDownBackground}00 50% )`};
        pointer-events: none;
        z-index: 1;
      }
    `}

    @media (max-width: ${LayoutConst.screen.s - 1}px){
      height: ${({dropdownHeight}) => dropdownHeight ? `${dropdownHeight}px` : '224px'};
    }
  }
  .target-icon-wrapper {
    .dropdown-header {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
        // color: ${({ theme }) => theme.icon.default};

    }

    svg path {
      fill: ${({ theme }) => theme.icon.default};
    }
  }

  .dropdown-list-item {
    min-height: 40px;
    background: ${({theme}: any) => theme.navigationBar.login.dropDownBackground};

    &:hover {
      background: ${({ theme }) => theme.navigationBar.login.dropDownHoverBackground};

      div {
        color: ${({ theme }) => theme.viewType.item.hover};
      }
        
      span{
        color: ${({ theme }) => theme.viewType.item.hover};
      }
    }
    div, span {
      font-size: 15px;
      line-height: 20px;
    }    
  }
  ${p => (p.isAcademy || p.isGameDeziiign) && 
    css`
    .dropdown-show {       
        .dropdown-list-item {
            background: #3F4548;
            & > div {
                color: #ABAEAF;
            }
            .active {
                color: #FFF;
                svg path {
                    fill: #fefefe;
                }
            }
            &:hover {
                background: #575B5E;
                & > div {
                    color: #ABAEAF;
                }
            }
        }
    }        
    `
  }
`

export const DropdownTabs: FC<{
    items: Record<string, ReactNode | string | LinksItems>;
    activeTabKey: string;
    onChange: (indexKey: string) => void;
    onTeamClick?: () => void;
    onShopClick?: () => void;
    whiteTheme?: boolean;
    hasEmployees?: boolean;
    isShort?: boolean,
    mobileShrink?: boolean
    activeText?: boolean
    customTitleTheme?: any
    isAcademy?: boolean
    projectsLength?: number | string
    displayShop?: boolean
    isSuperPuperGames?: boolean
}> = ({
    items,
    onChange,
    activeTabKey,
    whiteTheme,
    hasEmployees,
    onTeamClick,
    onShopClick,
    isShort,
    mobileShrink,
    customTitleTheme,
    activeText,
    isAcademy,
    projectsLength,
    displayShop,
    isSuperPuperGames
}) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const importantItemColor = useSelector(ThemeSlideColorSelector)?.slideColor;
    const isGameDeziiign = AppTester.isGameDeziiign();
    const isCompetition = AppTester.isCompetition();
    const isMediaSport = AppTester.isMediiiaSport()

    const hideArrow = useMemo(() => {
      return Object.keys(items)?.length === 1;
  }, [items]);

  const dropdownItemsCount = useMemo(() => {
      return Object.keys(items).length;
  }, [items]);

  const { dropdownHeight, showScroll } = useMemo(() => {
      if (dropdownItemsCount === 0) {
          return { dropdownHeight: 0, showScroll: true };
      }
      
      const itemHeight = 44;
      const maxHeight = 224;
      const calculatedHeight = dropdownItemsCount * itemHeight;
      
      
      if (dropdownItemsCount <= 5) {
          return { dropdownHeight: 'auto', showScroll: false };
      }
      //кансер какой-то, но зачем-то сказали сделать
      return { dropdownHeight: isMediaSport? calculatedHeight : maxHeight, showScroll: true };
  }, [dropdownItemsCount]);

    const text = <ArrowTopIconWithText
        //@ts-ignore
        text={typeof items[activeTabKey] === 'string' ? items[activeTabKey] : items[activeTabKey]?.element()}
        shrimpIcon
        active={activeText}
        hideIcon={hideArrow}
        mobileShrink={mobileShrink}
        isShort={isShort}
        fill={'#909090'}
        importantColor={importantItemColor?.color}
        isCompetition={true}
        projectsLength={projectsLength}
        isSuperPuperGames={isSuperPuperGames}
    />

    return (
        <DropDownWrapper isCompetition={isCompetition} isAcademy={isAcademy} isGameDeziiign={isGameDeziiign} dropdownHeight={dropdownHeight} showScroll={showScroll}>
        <Dropdown
        offsetY={12}
        // offsetX={is744BP ? 0 : -2}
        dark={whiteTheme}
        hideArrow
        orientation={'left'}
        maxHeight={typeof dropdownHeight === 'number' ? dropdownHeight : undefined}
        target={customTitleTheme ? <ThemeProvider theme={customTitleTheme}>{text}</ThemeProvider> : text}
      >
        {Object.keys(items)?.map((key) => {
            //todo replace with different logic
          const isObject = typeof items[key] !== 'string';
          return (
            <div key={key} onClick={() => {
            //   if (key === activeTabKey) return false;
            //   //@ts-ignore
            //   if (isLink) return tabItems[key]?.action()
                if (isObject) {
                    //@ts-ignore
                    items[key]?.action();
                } else {
                    onChange(key);
                }
            }}>
              <DropdownListItem
                justify='space-between'
                isActive={key === activeTabKey}
              >
                <DropdownText className={key === activeTabKey ? 'active' : ''} isActive={key === activeTabKey}>
                  {/*@ts-ignore*/}
                  {isObject ? items[key]?.element() : items[key]}
                </DropdownText>
                <ApprovedIcon fill={theme.icon.active} display={key === activeTabKey}/>
              </DropdownListItem>
            </div>
          )
        }
        )}
        {hasEmployees && <div key={'team'} onClick={() => onTeamClick && onTeamClick()}>
            <DropdownListItem
                justify='flex-start'
                isActive={false}
            >
                <DropdownText isActive={false} style={{marginRight: '4px'}}>
                    {t('nav.team')}
                </DropdownText>
                <svg
                    width='16'
                    height='20'
                    viewBox='0 0 16 14'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path
                        fill={theme.icon.hoverSpecialActive}
                        d='M12 10.7149H10.3329L10.3431 6.86984L5.21474 12L4 10.786L9.12833 5.65587H5.27573L5.2859 4H12V10.7149Z'
                    />
                </svg>
            </DropdownListItem>
        </div>}
        {displayShop && onShopClick && <div key={'shop'} onClick={() => onShopClick && onShopClick()}>
            <DropdownListItem
                justify='flex-start'
                isActive={false}
            >
                <DropdownText isActive={false} style={{marginRight: '4px'}}>
                    {t('nav.shop')}
                </DropdownText>
                <svg
                    width='16'
                    height='20'
                    viewBox='0 0 16 14'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path
                        fill={theme.icon.hoverSpecialActive}
                        d='M12 10.7149H10.3329L10.3431 6.86984L5.21474 12L4 10.786L9.12833 5.65587H5.27573L5.2859 4H12V10.7149Z'
                    />
                </svg>
            </DropdownListItem>
        </div>}
      </Dropdown>
      </DropDownWrapper>
    )
}import { Dropdown, DropdownListItem, FInter, FlexBox } from "@brg/ui";
import { FC, ReactNode, useMemo } from "react";
import { ApprovedIcon } from "shared/icons/ApprovedIcon";
import ArrowTopIconWithText from "shared/icons/ArrowTopIconWithText";
import styled, {css, ThemeProvider, useTheme} from 'styled-components';
import {useTranslation} from "react-i18next";
import { useSelector } from "react-redux";
import { ThemeSlideColorSelector } from "../../../reducers/ThemeSlideColorSlice";
import { AppTester } from "supporting";
import { LayoutConst } from "core";

export interface LinksItems {
    action: () => void;
    isLinks: boolean;
    element: ReactNode;
  }

const DropdownText = styled(FInter.SmallTextBoldMagic)<{ isActive?: boolean }>`
  font-size: 15px;
  line-height: 20px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: ${p => p?.isActive ? p.theme.icon.active : p.theme.icon.hoverSpecialActive};
`;

export const DropDownWrapper = styled(FlexBox)<{ 
  isGameDeziiign?: boolean, 
  dropdownHeight?: number | string | undefined, 
  showScroll?: boolean, 
  isAcademy?: boolean,
  isCompetition?: boolean
}>`
    position: relative;
  
  .dropdown-show {
    height: auto;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1000;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

    >div{
      overflow: ${({showScroll}) => showScroll ? 'auto' : 'visible'} !important;
      ${({showScroll}) => showScroll && `
        &::-webkit-scrollbar {
            height: 1px;
            width: 2px;
          }
          &::-webkit-scrollbar-track {
            border-radius: 10px;
            background: ${({theme}: any) => theme.competition.input.bgActive} !important;
          }
          &::-webkit-scrollbar-thumb {
            background: ${({theme}: any) => theme.competition.input.inputText} !important;
          }
      `}
    }

    ${({ showScroll, theme, dropdownHeight }) => showScroll && `
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 40px;
        background: ${dropdownHeight === 0 ? `` : `linear-gradient(to top, ${theme.navigationBar.login.dropDownBackground} 0%, ${theme.navigationBar.login.dropDownBackground}00 50% )`};
        pointer-events: none;
        z-index: 1;
      }
    `}

    @media (max-width: ${LayoutConst.screen.s - 1}px){
      height: ${({dropdownHeight}) => dropdownHeight ? `${dropdownHeight}px` : '224px'};
    }
  }
  .target-icon-wrapper {
    .dropdown-header {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
        // color: ${({ theme }) => theme.icon.default};

    }

    svg path {
      fill: ${({ theme }) => theme.icon.default};
    }
  }

  .dropdown-list-item {
    min-height: 40px;
    background: ${({theme}: any) => theme.navigationBar.login.dropDownBackground};

    &:hover {
      background: ${({ theme }) => theme.navigationBar.login.dropDownHoverBackground};

      div {
        color: ${({ theme }) => theme.viewType.item.hover};
      }
        
      span{
        color: ${({ theme }) => theme.viewType.item.hover};
      }
    }
    div, span {
      font-size: 15px;
      line-height: 20px;
    }    
  }
  ${p => (p.isAcademy || p.isGameDeziiign) && 
    css`
    .dropdown-show {       
        .dropdown-list-item {
            background: #3F4548;
            & > div {
                color: #ABAEAF;
            }
            .active {
                color: #FFF;
                svg path {
                    fill: #fefefe;
                }
            }
            &:hover {
                background: #575B5E;
                & > div {
                    color: #ABAEAF;
                }
            }
        }
    }        
    `
  }
`

export const DropdownTabs: FC<{
    items: Record<string, ReactNode | string | LinksItems>;
    activeTabKey: string;
    onChange: (indexKey: string) => void;
    onTeamClick?: () => void;
    onShopClick?: () => void;
    whiteTheme?: boolean;
    hasEmployees?: boolean;
    isShort?: boolean,
    mobileShrink?: boolean
    activeText?: boolean
    customTitleTheme?: any
    isAcademy?: boolean
    projectsLength?: number | string
    displayShop?: boolean
    isSuperPuperGames?: boolean
}> = ({
    items,
    onChange,
    activeTabKey,
    whiteTheme,
    hasEmployees,
    onTeamClick,
    onShopClick,
    isShort,
    mobileShrink,
    customTitleTheme,
    activeText,
    isAcademy,
    projectsLength,
    displayShop,
    isSuperPuperGames
}) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const importantItemColor = useSelector(ThemeSlideColorSelector)?.slideColor;
    const isGameDeziiign = AppTester.isGameDeziiign();
    const isCompetition = AppTester.isCompetition();
    const isMediaSport = AppTester.isMediiiaSport()

    const hideArrow = useMemo(() => {
      return Object.keys(items)?.length === 1;
  }, [items]);

  const dropdownItemsCount = useMemo(() => {
      return Object.keys(items).length;
  }, [items]);

  const { dropdownHeight, showScroll } = useMemo(() => {
      if (dropdownItemsCount === 0) {
          return { dropdownHeight: 0, showScroll: true };
      }
      
      const itemHeight = 44;
      const maxHeight = 224;
      const calculatedHeight = dropdownItemsCount * itemHeight;
      
      
      if (dropdownItemsCount <= 5) {
          return { dropdownHeight: 'auto', showScroll: false };
      }
      //кансер какой-то, но зачем-то сказали сделать
      return { dropdownHeight: isMediaSport? calculatedHeight : maxHeight, showScroll: true };
  }, [dropdownItemsCount]);

    const text = <ArrowTopIconWithText
        //@ts-ignore
        text={typeof items[activeTabKey] === 'string' ? items[activeTabKey] : items[activeTabKey]?.element()}
        shrimpIcon
        active={activeText}
        hideIcon={hideArrow}
        mobileShrink={mobileShrink}
        isShort={isShort}
        fill={'#909090'}
        importantColor={importantItemColor?.color}
        isCompetition={true}
        projectsLength={projectsLength}
        isSuperPuperGames={isSuperPuperGames}
    />

    return (
        <DropDownWrapper isCompetition={isCompetition} isAcademy={isAcademy} isGameDeziiign={isGameDeziiign} dropdownHeight={dropdownHeight} showScroll={showScroll}>
        <Dropdown
        offsetY={12}
        // offsetX={is744BP ? 0 : -2}
        dark={whiteTheme}
        hideArrow
        orientation={'left'}
        maxHeight={typeof dropdownHeight === 'number' ? dropdownHeight : undefined}
        target={customTitleTheme ? <ThemeProvider theme={customTitleTheme}>{text}</ThemeProvider> : text}
      >
        {Object.keys(items)?.map((key) => {
            //todo replace with different logic
          const isObject = typeof items[key] !== 'string';
          return (
            <div key={key} onClick={() => {
            //   if (key === activeTabKey) return false;
            //   //@ts-ignore
            //   if (isLink) return tabItems[key]?.action()
                if (isObject) {
                    //@ts-ignore
                    items[key]?.action();
                } else {
                    onChange(key);
                }
            }}>
              <DropdownListItem
                justify='space-between'
                isActive={key === activeTabKey}
              >
                <DropdownText className={key === activeTabKey ? 'active' : ''} isActive={key === activeTabKey}>
                  {/*@ts-ignore*/}
                  {isObject ? items[key]?.element() : items[key]}
                </DropdownText>
                <ApprovedIcon fill={theme.icon.active} display={key === activeTabKey}/>
              </DropdownListItem>
            </div>
          )
        }
        )}
        {hasEmployees && <div key={'team'} onClick={() => onTeamClick && onTeamClick()}>
            <DropdownListItem
                justify='flex-start'
                isActive={false}
            >
                <DropdownText isActive={false} style={{marginRight: '4px'}}>
                    {t('nav.team')}
                </DropdownText>
                <svg
                    width='16'
                    height='20'
                    viewBox='0 0 16 14'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path
                        fill={theme.icon.hoverSpecialActive}
                        d='M12 10.7149H10.3329L10.3431 6.86984L5.21474 12L4 10.786L9.12833 5.65587H5.27573L5.2859 4H12V10.7149Z'
                    />
                </svg>
            </DropdownListItem>
        </div>}
        {displayShop && onShopClick && <div key={'shop'} onClick={() => onShopClick && onShopClick()}>
            <DropdownListItem
                justify='flex-start'
                isActive={false}
            >
                <DropdownText isActive={false} style={{marginRight: '4px'}}>
                    {t('nav.shop')}
                </DropdownText>
                <svg
                    width='16'
                    height='20'
                    viewBox='0 0 16 14'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path
                        fill={theme.icon.hoverSpecialActive}
                        d='M12 10.7149H10.3329L10.3431 6.86984L5.21474 12L4 10.786L9.12833 5.65587H5.27573L5.2859 4H12V10.7149Z'
                    />
                </svg>
            </DropdownListItem>
        </div>}
      </Dropdown>
      </DropDownWrapper>
    )
}